<template lang="pug">
  div.mt-16
    .font-600.text-left.mb-10(v-if="title" :class="setTextClass(titleColor)") {{title}}
    //- div {{data.length}}
    //- div {{taleExtend}}
    //- div {{data}}
    //- div {{isHightLight}} 12345 {{extendCat}}
    .w-full
      table.text-sm.w-full.text-left
        thead
          tr.border-b.text-12(:class="styleCustom()")
            td.p-3.px-10(v-for="col in columns" :width="col.width" )
              slot(:name="col.customHeadRender" v-if="col.customHeadRender")
              span.normal(v-else ) {{col.title}}
        tbody(v-for="(row,rowIndex) in local" v-if="local.length")
          tr.border-grey-d9( class="hover:bg-grey-fa" :class="{'border-b' : !taleExtend[rowIndex]}" ref="colorBG" @mouseover="highLightHoverEffect(rowIndex)" )
            td.p-3.px-10(v-for="(col,i) in columns" :class="styleCustom()")
              //- div {{col,i}}
              slot(:name="col.customBodyRender" :text="row[col.key]" :dataIndex="row" v-if="col.customBodyRender")
              span.normal(v-if="!col.customBodyRender && col.key != 'severity'") {{row[col.key]}}
              .flex.items-center.justify-start(v-if="col.key == 'severity'")
                .rounded-50.min-w-10.h-10.mr-5(:class="{'bg-safe':row[col.key] == '2', 'bg-warn':row[col.key] == '5', 'bg-error':row[col.key] == '8' }")
                span(v-text="getSeverity(row[col.key])") 
              .flex.items-center.justify-between(v-if="i == columns.length-1 && hasExtendButton")
                div.origin-center.transition.duration-300.ease-in-out.rounded-50(v-if="disableShow(row[hasExtendButton])" @click="extend(rowIndex,'table',row)" class="hover:bg-grey-f2 active:bg-main-0 active:text-white" :class="{'transform':taleExtend[rowIndex], '-rotate-180': taleExtend[rowIndex]}")
                  iCon.h-24.w-24.inline-block.cursor-pointer(:iconClass="'dropdown'"  type="svg") 
          tr()
            //:class="{'border-b' : taleExtend[rowIndex],'pb-10' : taleExtend[rowIndex]}"
            td(:colspan="columns.length")
              //- div {{row['downloadSource']}}
              .transition.max-h-0.overflow-hidden.w-full(:class="{'maxHeight':taleExtend[rowIndex],'border-b' : taleExtend[rowIndex],'pb-20' : taleExtend[rowIndex]}" )
                slot(:name="'third'" :thirdDataIndex="row" :third="row.previousVersion"  :index="rowIndex" :title="title")
                //v-if="data!==undefined && data.length>0 ? 1 :0"
        tbody(v-if="!local.length")
          tr
            td.text-center(:colspan="columns.length")
              slot(:name="'empty'" :text="'No Result'")
</template>

<script>
import { DOWNLOAD } from "@/enum/global";
export default {
  name: "TableEach",
  props: {
    modelName: {
      type: String,
      required: false
    },
    data: {
      type: [Array, Object],
      required: false
    },
    title: {
      type: String,
      required: false
    },
    columns: {
      type: Array,
      required: true
    },
    titleColor: {
      type: String,
      required: false
    },
    colorCustom: {
      type: String,
      required: false,
      default: "black"
    },
    extendArr: {
      type: [Array],
      required: false
    },
    isHightLight: {
      type: String,
      required: false
    },
    extendCat: {
      type: String,
      required: false
    },
    hasExtendButton: {
      type: String,
      required: false
    }
  },
  components: {},
  data() {
    return {
      mainSelect: "",
      isExtend: [],
      taleExtend: [],
      local: [],
      localColor: ""
    };
  },
  created() {},
  mounted() {
    this.local = this.data;
    if (this.data !== undefined && this.data.length > 0 ? 1 : 0) {
      this.data.forEach(() => {
        this.isExtend.push(false);
        this.taleExtend.push(false);
      });
    }
  },
  methods: {
    styleCustom() {
      let result = [];
      result.push(`border-${this.colorCustom}`);
      result.push(`text-${this.colorCustom}`);
      return result;
    },
    disableShow(showItems) {
      // console.log(showItems)
      let result = true;
      if (showItems.length) {
        for (let i = 0; i < showItems.length; i++) {
          //不秀的條件
          // if(showItems[i].val ==DOWNLOAD['INIT'] || showItems[i].val == DOWNLOAD['PROCESSING'] ){
          //   result = false
          // }
        }
      }
      return result;
    },
    getSeverity(text) {
      switch (text) {
        case 2 || "2":
          return this.$t("__dataTable.__optional");
        case 5 || "5":
          return this.$t("__dataTable.__recommend");
        case 8 || "8":
          return this.$t("__dataTable.__urgent");
      }
    },
    extend(e, word, row) {
      if (word === "normal") {
        this.$set(this.isExtend, e, !this.isExtend[e]);
      } else {
        this.$set(this.taleExtend, e, !this.taleExtend[e]);
      }
    },
    setTextClass(color) {
      return {
        ["text-main-0"]: !color,
        [`${color}`]: color
      };
    },
    closeExtend() {
      for (let i = 0; i < this.taleExtend.length; i++) {
        this.taleExtend[i] = false;
      }
      // console.log(this.local)
      if (this.isHightLight) {
        this.localColor = this.isHightLight;
        this.goHighLight();
      } else {
        // console.log('清除')
        this.cleanHighLight();
      }
    },
    cleanHighLight() {
      this.$nextTick(function() {
        if (this.local.length) {
          //因為有些category已經被剃除了，所以要判斷
          if (this.local[0].category == this.extendCat) {
            //先找到是哪個category
            for (let e = 0; e < this.local.length; e++) {
              if (this.local[e].name != this.localColor) {
                this.highLightHoverEffect(e);
              }
            }
          }
        }
      });
    },
    goHighLight() {
      let colorIndex = 0;
      this.$nextTick(function() {
        if (this.local[0].category == this.extendCat) {
          //先找到是哪個category
          for (let e = 0; e < this.local.length; e++) {
            if (this.local[e].name == this.localColor) {
              colorIndex = e;
              this.$refs.colorBG[colorIndex].classList.add("colorBG");
              this.$emit("hightLightChange");
            }
          }
        }
      });
    },
    highLightHoverEffect(i) {
      this.$refs.colorBG[i].classList.remove("colorBG");
    }
  },
  watch: {
    data: {
      handler: function(n, o) {
        //驗證有填選則開啟BTN
        this.local = n;
        this.closeExtend();
      },
      deep: true
    },
    isHightLight: {
      handler: function() {
        // this.localColor = n
      }
    },
    local: {
      handler: function(n, o) {
        //驗證有填選則開啟BTN
        if (n !== undefined && n.length > 0 ? 1 : 0) {
          n.forEach(e => {
            e.isExtend = false;
            e.taleExtend = false;
          });
        }
      },
      deep: true
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.transition {
  transition: 0.1s all linear;
}

.maxHeight {
  max-height: 9999px;
}

// table ,tr ,th,td{
//   border:cadetblue solid 2px;
// }
.disable {
}

.colorBG {
  @apply bg-grey-f2;
}
</style>
